// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3VpgF","col":"styles_col__2BU4y","fulfillmentStatus":"styles_fulfillmentStatus__BwJI6","emailCol":"styles_emailCol__25Cgo"};